import { Injectable } from '@angular/core';
import { IFunding } from '@bp-core/src/lib/models/portal/goal/funding.model';
import { IPortafolioFunding } from '@bp-core/src/lib/models/portal/goal/portfolio-funding.model';
import { IWhereMyMoney } from '@bp-core/src/lib/models/portal/goal/whereMyMoney.model';
import {
  FundingModel,
  GroupCategoryModel,
  PortfolioCompositionModel,
  PortfolioModel,
} from '@bp-core/src/lib/proto/common-message.pb';
import { ICustomCategoryFund } from 'projects/bp-core/src/lib/models/portal/goal/custom-category-fund.model';
import { ICustomFund } from 'projects/bp-core/src/lib/models/portal/goal/fund-custom.model';
import {
  IDualFundingPercentages,
  IGroupCategoryPercentage,
} from 'projects/bp-core/src/lib/models/portal/goal/funding-percentages.model';
import { ListSubCategoryWithFundsByFinancialEntityResponseDetail } from 'projects/bp-core/src/lib/proto/funding.pb';
import { ColorService } from './color.service';
@Injectable({
  providedIn: 'root',
})
export class GoalFundingService {
  constructor(private colorService: ColorService) {}
  /**
   *
   *
   * @param {IPortafolioFunding[]} funds from portfolio
   * @return {*}  {number} return stock percentage
   * @memberof GoalFundingService
   */
  getFundingStockPercentage(funds: IPortafolioFunding[]): number {
    let stockPercentage = 0;

    funds.forEach(fund => {
      fund?.funding?.compositions?.forEach(composition => {
        if (
          composition?.subcategory?.category?.isdisplayedingroupfunding &&
          composition?.subcategory?.category.groupdisplayuuid == 'acciones'
        ) {
          stockPercentage += (composition.percentage * fund.percentage) / 100;
        }
      });
    });
    return stockPercentage;
  }
  /**
   *
   *
   * @param {ICustomFund[]} funds from custom funding portfolio not created yet
   * @return {*}  {number} return stock percentage
   * @memberof GoalFundingService
   */
  getCustomFundingStockPercentage(funds: ICustomFund[]): IGroupCategoryPercentage[] {
    let categoryCounts: { [key: string]: number } = {};
    let groupCategoryPercentage: IGroupCategoryPercentage[] = [];
    funds.forEach(fund => {
      const groupCategory = this.getFundingGroupCategoryModel(fund.fund.fund!);

      if (!groupCategory) {
        return;
      }
      let alreadyExists = groupCategoryPercentage.find(
        g => g.groupCategoryTitle == groupCategory.title,
      );
      if (alreadyExists) {
        alreadyExists.percentage += fund.userPercentage!;
      } else {
        groupCategoryPercentage.push({
          groupCategoryTitle: groupCategory.title,
          groupCategoryUuid: groupCategory.uuid,
          color: groupCategory.color,
          percentage: fund.userPercentage!,
        });
      }

      // if (!categoryCounts[groupCategory]) {
      //   categoryCounts[categoryTitle] = 0;
      // }
      // categoryCounts[categoryTitle] += fund.userPercentage!;
    });
    return groupCategoryPercentage;
  }
  //   /**
  //    *
  //    *  function that return the risk value of provide stock percentage (Only on custom Portfolios)
  //    * @param {string} versionRiskLevel
  //    * @param {number} stockPercentage
  //    * @return {*}  {(Promise<IRiskLevel | undefined>)}
  //    * @memberof GoalFundingService
  //    */
  //   async getRiskLevelByEntityCustom(
  //     versionRiskLevel: string,
  //     stockPercentage: number,
  //   ): Promise<IRiskLevel | undefined> {
  //     if (!this.riskLevels) this.riskLevels = await lastValueFrom(this.riskLevelService.list());
  //     if (this.riskLevels) {
  //       let riskLevelsFiltered = this.riskLevels.filter(risk => risk.version == versionRiskLevel);
  //       if (stockPercentage == 0) return riskLevelsFiltered.find(risk => risk.position == 1);
  //       if (this.between(stockPercentage, 0, 25))
  //         return riskLevelsFiltered.find(risk => risk.position == 2);
  //       if (this.between(stockPercentage, 25, 50))
  //         return riskLevelsFiltered.find(risk => risk.position == 3);
  //       if (this.between(stockPercentage, 50, 75))
  //         return riskLevelsFiltered.find(risk => risk.position == 4);
  //       if (this.between(stockPercentage, 75, 100))
  //         return riskLevelsFiltered.find(risk => risk.position == 5);
  //     }
  //     return undefined;
  //   }
  /**
   *
   * function that return if value is inside a range
   * @param {number} x
   * @param {number} min
   * @param {number} max
   * @return {*}  {boolean}
   * @memberof GoalFundingService
   */
  between(x: number, min: number, max: number): boolean {
    return x > min && x <= max;
  }
  getNationalInternationalPortfolioComposition(
    nationalCode: string,
    compositions: PortfolioCompositionModel[],
    isBpUs: boolean,
  ): IDualFundingPercentages {
    let nationalPercentage = 0;
    let internationalPercentage = 0;
    let notAssigned = 0;
    let boxPercentage = compositions.find(c => c.isBox)?.percentage ?? 0;
    compositions
      .filter(x => !x.isBox)
      .forEach(composition => {
        if (
          composition?.subcategory?.category?.isDisplayedInGroupFunding &&
          composition?.subcategory?.country?.isoCode == nationalCode
        ) {
          nationalPercentage += composition.percentage!;
        } else {
          internationalPercentage += composition.percentage!;
        }
      });
    if (boxPercentage >= 100) {
      notAssigned = 0;
      internationalPercentage = 0;
      nationalPercentage = 0;
      if (isBpUs) {
        internationalPercentage = 100;
      } else {
        nationalPercentage = 100;
      }
    } else {
      const nationalFactor = (nationalPercentage * 100) / (100 - boxPercentage);
      const internationalFactor = (internationalPercentage * 100) / (100 - boxPercentage);

      nationalPercentage = nationalPercentage + (nationalFactor * boxPercentage) / 100;
      internationalPercentage =
        internationalPercentage + (internationalFactor * boxPercentage) / 100;

      // corrección de porcentajes si se pasan de 100
      const diff = 100 - (nationalPercentage + internationalPercentage);
      if (diff > 0) {
        if (isBpUs) {
          nationalPercentage = nationalPercentage + diff;
        } else {
          internationalPercentage = internationalPercentage + diff;
        }
      }
    }
    return {
      percentage1: Math.round(nationalPercentage),
      percentage2: Math.round(internationalPercentage),
      notAssignedPercentage: Math.round(notAssigned),
    };
  }

  getNationalInternationalCustomFundingPercentage(
    funds: ICustomFund[],
    isBpUs: boolean,
  ): IDualFundingPercentages {
    let nationalPercentage = 0;
    let internationalPercentage = 0;
    let notAssigned = 0;
    let boxPercentage = 1;

    funds.forEach(fund => {
      fund?.fund.fund?.fundingCompositions?.forEach(composition => {
        if (
          composition?.subcategory?.category?.isDisplayedInGroupFunding &&
          composition?.subcategory?.country?.isoCode == 'CL'
        ) {
          nationalPercentage += (composition.percentage! * fund.userPercentage!) / 100;
        } else {
          internationalPercentage += (composition.percentage! * fund.userPercentage!) / 100;
        }
      });
    });
    notAssigned = 100 - nationalPercentage - internationalPercentage - boxPercentage;
    nationalPercentage =
      (nationalPercentage * 100) / (nationalPercentage + internationalPercentage + notAssigned);

    if (Math.round(nationalPercentage + internationalPercentage + notAssigned) != 100) {
      if (isBpUs) {
        internationalPercentage += 1;
      } else {
        nationalPercentage += 1;
      }
    }

    return {
      percentage1: Math.round(nationalPercentage),
      percentage2: Math.round(internationalPercentage),
      notAssignedPercentage: Math.round(notAssigned),
    };
  }
  setWhereMyMoneyColors(whereMyMoney: IWhereMyMoney[]) {
    let categoryCounts: { [key: string]: number } = {};

    whereMyMoney.forEach(c => {
      if (c.funding.isBox) {
        c.color = this.colorService.getBlue(0);
        return;
      }

      let categoryKey = this.getFundingCategory(c.funding);

      // Si no hemos visto la categoría antes, inicialízala en categoryCounts
      if (!categoryCounts[categoryKey]) {
        categoryCounts[categoryKey] = 0;
      }

      let baseColor = c.funding.fundingCompositions?.find(
        f => f.subcategory?.category?.groupCategory?.uuid == categoryKey,
      )?.subcategory?.category?.groupCategory?.color;

      // Si no encuentras un color base, puedes tener una lógica de fallback aquí, o simplemente omitir ese caso

      c.color = this.colorService.getColor(categoryCounts[categoryKey], baseColor);
      categoryCounts[categoryKey]++;
    });

    return whereMyMoney;
  }

  getFundingCategory(funding: FundingModel): string {
    if (!funding.fundingCompositions) {
      return 'unknown';
    }

    const accumulatedPercentages = funding.fundingCompositions.reduce((acc, composition) => {
      const categoryUUID = composition.subcategory?.category?.groupCategory?.uuid;
      if (categoryUUID) {
        acc[categoryUUID] = (acc[categoryUUID] || 0) + composition.percentage;
      }
      return acc;
    }, {} as { [key: string]: number });

    // Identifica la categoría con el porcentaje más alto
    return Object.keys(accumulatedPercentages).reduce(
      (a, b) => (accumulatedPercentages[a] > accumulatedPercentages[b] ? a : b),
      'unknown',
    );
  }
  getFundingGroupCategoryModel(funding: FundingModel): GroupCategoryModel | null {
    if (!funding.fundingCompositions) {
      return null;
    }

    const accumulatedPercentages = funding.fundingCompositions.reduce((acc, composition) => {
      const categoryUUID = composition.subcategory?.category?.groupCategory?.uuid;
      if (categoryUUID) {
        acc[categoryUUID] = (acc[categoryUUID] || 0) + composition.percentage;
      }
      return acc;
    }, {} as { [key: string]: number });

    // Identifica la categoría con el porcentaje más alto
    const groupKey = Object.keys(accumulatedPercentages).reduce(
      (a, b) => (accumulatedPercentages[a] > accumulatedPercentages[b] ? a : b),
      'unknown',
    );
    return (
      funding.fundingCompositions.find(
        f => f.subcategory?.category?.groupCategory?.uuid == groupKey,
      )?.subcategory?.category?.groupCategory ?? null
    );
  }

  /**
   *
   *
   * @param {FundingModel} funding from portfolio
   * @return {*}  {boolean} return if funding is stock
   * @memberof GoalFundingService
   */
  fundingIsStock(funding: FundingModel | IFunding | undefined): boolean {
    let stockPercentage = 0;
    let bondPercentage = 0;
    if (funding instanceof FundingModel) {
      // Get the sum of the percentage of the stock subcategories
      stockPercentage =
        funding.fundingCompositions?.reduce((acc, curr) => {
          if (curr.subcategory?.category?.groupCategory?.uuid == 'stocks') {
            return acc + curr.percentage;
          }
          return acc;
        }, 0) ?? 0;

      // Get the sum of the percentage of the bond subcategories
      bondPercentage =
        funding.fundingCompositions?.reduce((acc, curr) => {
          if (curr.subcategory?.category?.groupCategory?.uuid == 'bonds') {
            return acc + curr.percentage;
          }
          return acc;
        }, 0) ?? 0;
    } else {
      // Get the sum of the percentage of the stock subcategories
      stockPercentage =
        funding?.compositions?.reduce((acc, curr) => {
          if (curr.subcategory?.category?.groupdisplayuuid == 'acciones') {
            return acc + curr.percentage;
          }
          return acc;
        }, 0) ?? 0;

      // Get the sum of the percentage of the bond subcategories
      bondPercentage =
        funding?.compositions?.reduce((acc, curr) => {
          if (curr.subcategory?.category?.groupdisplayuuid == 'bonos') {
            return acc + curr.percentage;
          }
          return acc;
        }, 0) ?? 0;
    }

    return stockPercentage > bondPercentage;
  }

  orderWhereMyMoney(a: IWhereMyMoney, b: IWhereMyMoney) {
    if (a.funding.isBox) return 1;
    if (b.funding.isBox) return -1;
    const aOrder =
      a.funding.fundingCompositions?.find(
        f => f.subcategory?.category?.groupCategory?.uuid === this.getFundingCategory(a.funding),
      )?.subcategory?.category?.groupCategory?.displayOrder ?? 0;

    const bOrder =
      b.funding.fundingCompositions?.find(
        f => f.subcategory?.category?.groupCategory?.uuid === this.getFundingCategory(b.funding),
      )?.subcategory?.category?.groupCategory?.displayOrder ?? 0;

    // Primer nivel de ordenamiento: por el order del groupCategory
    if (aOrder !== bOrder) {
      return aOrder - bOrder;
    }
    // Segundo nivel de ordenamiento: por porcentaje
    return b.percentage - a.percentage;
  }

  orderCustomFunds(a: ICustomFund, b: ICustomFund) {
    let aIsStock = this.fundingIsStock(a.fund.fund);
    let bIsStock = this.fundingIsStock(b.fund.fund);

    if (aIsStock && bIsStock) {
      return b.userPercentage! - a.userPercentage!;
    } else if (aIsStock) {
      return -1;
    } else if (bIsStock) {
      return 1;
    } else {
      return b.userPercentage! - a.userPercentage!;
    }
  }

  orderPortfolioFunds(a: IPortafolioFunding, b: IPortafolioFunding) {
    let aIsStock = this.fundingIsStock(a.funding);
    let bIsStock = this.fundingIsStock(b.funding);

    if (aIsStock && bIsStock) {
      return b.percentage - a.percentage;
    } else if (aIsStock) {
      return -1;
    } else if (bIsStock) {
      return 1;
    } else {
      return b.percentage - a.percentage;
    }
  }

  orderFundingComposition(a: PortfolioCompositionModel, b: PortfolioCompositionModel) {
    if (a.isBox) return 1;
    if (b.isBox) return -1;
    const aOrder = a.subcategory?.category?.groupCategory?.displayOrder ?? 0;
    const bOrder = b.subcategory?.category?.groupCategory?.displayOrder ?? 0;

    // Primer nivel de ordenamiento: por el order del groupCategory
    if (aOrder !== bOrder) {
      return aOrder - bOrder;
    }
    // Segundo nivel de ordenamiento: por porcentaje
    return b.percentage - a.percentage;
  }
  setFundingColors(compositions: PortfolioCompositionModel[]) {
    let stockCount = 0;
    let bondCount = 0;
    compositions.forEach(c => {
      let isStock = c.subcategory?.category?.groupCategory?.uuid == 'stocks';
      let baseColor = c.subcategory?.category?.groupCategory?.color;

      if (isStock) {
        c.color = this.colorService.getColor(stockCount, baseColor);
        stockCount++;
      } else {
        c.color = this.colorService.getColor(bondCount, baseColor);
        bondCount++;
      }
    });

    return compositions;
  }
  setPortfolioFundingColors(funds: IPortafolioFunding[]) {
    let stockCount = 0;
    let bondCount = 0;
    funds.forEach(f => {
      let isStock = f.funding?.compositions?.find(
        c => c.subcategory?.category?.groupdisplayuuid == 'acciones',
      );
      f.color = isStock
        ? this.colorService.getGreen(stockCount)
        : this.colorService.getBlue(bondCount);
      if (isStock) {
        stockCount++;
      } else {
        bondCount++;
      }
    });

    return funds;
  }
  getSubCategoryFundsWithCustomFunds(
    portfolio?: PortfolioModel,
    array?: ListSubCategoryWithFundsByFinancialEntityResponseDetail[],
    defaultPercentage?: number,
  ) {
    let newArrayWithDefault: ICustomCategoryFund[] = [];
    if (array) {
      let categoryCounts: { [key: string]: number } = {};

      var acc = -1;
      var stockCount = -1;
      var bondCount = -1;
      var needsBalance = { fundId: 0, categoryIndex: -1 };
      array.forEach((category, index) => {
        let duplicateIndex = newArrayWithDefault.findIndex(
          value => value.category.categoryDisplayName == category.categoryDisplayName,
        );

        let customFunds: ICustomFund[] = category.customFunds?.map(customFund => {
          acc++;
          let categoryKey = this.getFundingCategory(customFund.fund!);
          const groupCategoryDisplayOrder = customFund.fund?.fundingCompositions?.find(
            f => f.subcategory?.category?.groupCategory?.uuid == categoryKey,
          )?.subcategory?.category?.groupCategory?.displayOrder;

          // Si no hemos visto la categoría antes, inicialízala en categoryCounts
          if (!categoryCounts[categoryKey]) {
            categoryCounts[categoryKey] = 0;
          }
          let baseColor = customFund.fund?.fundingCompositions?.find(
            f => f.subcategory?.category?.groupCategory?.uuid == categoryKey,
          )?.subcategory?.category?.groupCategory?.color;
          const searchObject = portfolio?.portfolioFunding!.find(
            f => f.fundingId == customFund.fund?.id,
          );
          if (searchObject?.percentage! < 5 && searchObject?.percentage! > 0)
            needsBalance = { fundId: customFund.fund?.id!, categoryIndex: index };
          categoryCounts[categoryKey]++;

          let percentage = searchObject ? searchObject.percentage : 0;
          if (defaultPercentage != undefined) percentage = defaultPercentage;

          return {
            fund: customFund,
            defaultPercentage: Math.floor(searchObject ? searchObject.percentage : 0),
            userPercentage: Math.floor(percentage),
            color: this.colorService.getColor(categoryCounts[categoryKey], baseColor),
            category: category,
            groupCategoryDisplayOrder: groupCategoryDisplayOrder!,
          };
        })!;
        if (duplicateIndex == -1) {
          newArrayWithDefault.push({ category, customFunds });
        } else {
          //esta duplicada la categoría
          newArrayWithDefault[duplicateIndex].customFunds = [
            ...newArrayWithDefault[duplicateIndex].customFunds,
            ...customFunds,
          ];
        }
        //   newArrayWithDefault.push({ category, customFunds });
      });
      // esto ocurre si existe un fondo que tiene menos del 5%, se debe quitar al que mas % tiene en todas las categorías
      if (needsBalance.fundId != 0) {
        let needsBalanceFundIndex = newArrayWithDefault[
          needsBalance.categoryIndex
        ].customFunds?.findIndex(fund => fund.fund.fund?.id == needsBalance.fundId);
        let missingPercentage =
          5 -
          newArrayWithDefault[needsBalance.categoryIndex].customFunds[needsBalanceFundIndex]
            .userPercentage!;
        newArrayWithDefault[needsBalance.categoryIndex].customFunds[
          needsBalanceFundIndex
        ].userPercentage = newArrayWithDefault[needsBalance.categoryIndex].customFunds[
          needsBalanceFundIndex
        ].defaultPercentage = 5;

        var max = -Infinity;
        var maxFundIndex = -1;
        var maxCategoryIndex = -1;

        newArrayWithDefault.forEach((category, categoryIndex) => {
          category.customFunds.forEach((fund, fundIndex) => {
            if (max < +fund.userPercentage!) {
              max = +fund.userPercentage!;
              maxFundIndex = fundIndex;
              maxCategoryIndex = categoryIndex;
            }
          });
        });
        if (maxCategoryIndex != -1 && maxFundIndex != -1) {
          newArrayWithDefault[maxCategoryIndex].customFunds[maxFundIndex].userPercentage =
            newArrayWithDefault[maxCategoryIndex].customFunds[maxFundIndex].userPercentage! -
            missingPercentage;
          newArrayWithDefault[maxCategoryIndex].customFunds[maxFundIndex].defaultPercentage =
            newArrayWithDefault[maxCategoryIndex].customFunds[maxFundIndex].defaultPercentage! -
            missingPercentage;
        }
      }
    }
    return newArrayWithDefault;
  }
  /**
   * Retrieves the new sub-category funds with custom funds.
   *
   * @param data - An object containing the old and new custom category funds.
   * @returns An array of custom category funds including the new funds.
   */
  getNewSubCategoryFundsWithCustomFunds(data: {
    old: ICustomCategoryFund[];
    new: ICustomCategoryFund;
  }) {
    let newArray: ICustomCategoryFund[] = [];
    // Obtenemos el uui del grupo de la categoría ej: stocks, bonds
    let categoryKey = this.getFundingCategory(data.new.customFunds[0].fund.fund!);

    // Obtenemos el color base de la categoría
    let baseColor = data.new.customFunds[0].fund?.fund?.fundingCompositions?.find(
      f => f.subcategory?.category?.groupCategory?.uuid == categoryKey,
    )?.subcategory?.category?.groupCategory?.color;

    // Buscar cuantos customFunds tienen este categoryKey
    let categoryCount = data.old.reduce((acc, curr) => {
      return (
        acc +
        curr.customFunds.filter(f => this.getFundingCategory(f.fund.fund!) == categoryKey).length
      );
    }, 1);

    data.new.customFunds.forEach(customFund => {
      customFund.color = this.colorService.getColor(categoryCount, baseColor);
      categoryCount++;
    });

    // Verificamos si la categoría ya existe
    const categoryAdded = data.old.find(
      value => value.category.categoryId == data.new.category.categoryId,
    );

    if (categoryAdded) {
      // Si la categoría ya existe, solo agregamos los customFunds nuevos
      categoryAdded.customFunds = [...categoryAdded.customFunds, ...data.new.customFunds];
      newArray = [...data.old];
    } else {
      // Si la categoría no existe, la agregamos al arreglo
      newArray = [...data.old, data.new];
    }

    return newArray;
  }
  getFeaturesSplit(feature: string, index: number) {
    let splitfeatures: string[] = [];
    try {
      if (feature.split(':').length > 1) {
        splitfeatures = feature.split(':');
      } else {
        splitfeatures.push(feature);
        splitfeatures.push('');
      }
    } catch (error) {
      console.log('getFeaturesSplit', error);
    }

    try {
      return splitfeatures[index];
    } catch (error) {
      return '';
    }
  }
}
